import { render } from "./RefundDetail.vue?vue&type=template&id=c8362fc8&scoped=true"
import script from "./RefundDetail.vue?vue&type=script&lang=js"
export * from "./RefundDetail.vue?vue&type=script&lang=js"

import "./RefundDetail.vue?vue&type=style&index=0&id=c8362fc8&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8362fc8"]])

export default __exports__